const resolveDate = (value) => {
  if (!value) return null;
  if (value instanceof Date) return value;
  if (typeof value === 'string') {
    const match = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (match) {
      const [, year, month, day] = match;
      return new Date(Number(year), Number(month) - 1, Number(day));
    }
  }
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const formatDateMDY = (value, fallback = '—') => {
  const date = resolveDate(value);
  if (!date) return fallback;
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const year = date.getFullYear();
  return `${month}/${day}/${year}`;
};

export const formatDateMDYWithWeekday = (value, fallback = '—') => {
  const date = resolveDate(value);
  if (!date) return fallback;
  const weekday = date.toLocaleDateString('en-US', { weekday: 'short' });
  return `${weekday} ${formatDateMDY(date, fallback)}`;
};
